module.exports = __webpack_public_path__ + "static/media/2022-Bikie-Code-Feature-banner-Desktop@1x.36dbc65f.jpg";